import React, { useState, useEffect, useRef } from "react";
import useChatPusher from "./useChatPusher";

const ChatWindow = ({ conversationId, token, currentUser }) => {
  const [messages, setMessages] = useState([]);
  const [body, setBody] = useState("");
  const [attachments, setAttachments] = useState([]);
  const messagesEndRef = useRef(null);

  // Real-time Pusher hook
  useChatPusher(conversationId, (newMessage) => {
    setMessages((prev) => [...prev, newMessage]);
  });

  // Fetch existing messages
  useEffect(() => {
    fetch(`/api/conversations/${conversationId}/messages`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setMessages(data);
      });
  }, [conversationId]);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleFileChange = (e) => {
    setAttachments([...e.target.files]);
  };

  const handleSend = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("conversation_id", conversationId);
    formData.append("body", body);
    attachments.forEach((file) => {
      formData.append("attachments[]", file);
    });

    const res = await fetch("/api/messages", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    const newMessage = await res.json();
    setMessages((prev) => [...prev, newMessage]);
    setBody("");
    setAttachments([]);
  };

  return (
    <div className="chat-window">
      <div className="messages" style={{ height: "400px", overflowY: "auto" }}>
        {messages.map((msg) => (
          <div
            key={msg.id}
            style={{
              textAlign: msg.sender.id === currentUser.id ? "right" : "left",
              marginBottom: "12px",
            }}
          >
            <div>
              <strong>{msg.sender.name}</strong>
            </div>
            <div>{msg.body}</div>
            {msg.attachments &&
              msg.attachments.map((file) => (
                <div key={file.id}>
                  <a
                    href={`/storage/${file.file_path}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📎 {file.original_name}
                  </a>
                </div>
              ))}
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      <form onSubmit={handleSend} style={{ marginTop: "10px" }}>
        <textarea
          value={body}
          onChange={(e) => setBody(e.target.value)}
          placeholder="Type your message..."
          rows={3}
          style={{ width: "100%", marginBottom: "5px" }}
        />
        <input type="file" multiple onChange={handleFileChange} />
        <button type="submit">Send</button>
      </form>
    </div>
  );
};

export default ChatWindow;
